import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Product } from '../../types/content';
export function ProductCard({
  product
}: {
  product: Product;
}) {
  return <li className="flex" data-id="element-231" data-mp="1o3x1kqw8vdb1">
      <Link to={`/shop/${product.slug}`} className="group flex w-full flex-col border border-ink/15 bg-cream-light transition-colors duration-150 ease-republic hover:border-ink" data-id="element-232" data-mp="1o580acau1uva">
        <div className="overflow-hidden bg-stone-light" data-id="element-233" data-mp="1xzzz1jg5inrn">
          <img src={product.image} alt={`${product.name}, ${product.form}`} className="aspect-square w-full object-cover transition-transform duration-300 ease-republic group-hover:scale-[1.02]" data-id="element-234" data-mp="1t3jbaqcv6bf3" />
        </div>

        <div className="flex flex-1 flex-col p-6" data-id="element-235" data-mp="221buw6pmc58a">
          <div className="flex items-center gap-2" data-id="element-236" data-mp="cpjdpm1hqxv0">
            <span className={`text-[0.625rem] uppercase tracking-label ${product.category === 'FDA-approved' ? 'text-brick' : 'text-ink-muted'}`} data-id="element-237" data-mp="cqb9oxz02xlt">
              {product.status}
            </span>
          </div>

          <h3 className="mt-3 font-serif text-2xl leading-tight text-ink" data-id="element-238" data-mp="3lrl8lmqh99vh">{product.name}</h3>
          <p className="mt-2 text-sm text-ink-muted" data-id="element-239" data-mp="3qolcps3ro2jy">
            {product.form} · {product.strength}
          </p>
          <p className="mt-4 text-sm leading-relaxed text-ink-soft" data-id="element-240" data-mp="3vi7id0bij669">{product.tagline}</p>

          <div className="rule mt-auto flex items-end justify-between gap-4 pt-5" data-id="element-241" data-mp="3cu3k4yq04vf">
            <div data-id="element-242" data-mp="8avkokcl5u49">
              <p className="font-serif text-3xl leading-none text-ink" data-id="element-243" data-mp="8ac4p96hxfsv">
                ${product.price}
                <span className="ml-2 font-sans text-xs text-ink-muted" data-id="element-244" data-mp="d96uww6sm6n0">{product.cadence}</span>
              </p>
              <p className="mt-2 text-xs text-ink-muted" data-id="element-245" data-mp="i809yt1qa5pa">{product.priceNote}</p>
            </div>
            <ArrowRightIcon className="mb-1 h-5 w-5 shrink-0 text-brick transition-transform duration-200 ease-republic group-hover:translate-x-1" strokeWidth={1.5} data-id="element-246" data-mp="2f4zfz5ptrobx" />
          </div>
        </div>
      </Link>
    </li>;
}